import React from 'react'
import "./Resume.css"
import point from "../../assets/bulletpoint.svg"
import waheedResume from "../../assets/waheedResume.svg"
import resume1 from "../../assets/resume1.svg"
import bluebg from "../../assets/resumeDarkBox.svg"
import logoBack from "../../assets/icons/bg.svg"
import alrabih from "../../assets/icons/resumesIcons/alrabih.png"
import alrajihi from "../../assets/icons/resumesIcons/alrajhi.png"
import century21 from "../../assets/icons/resumesIcons/century21.png"
import daim from "../../assets/icons/resumesIcons/daim.png"
import darkfooter from "../../assets/darkblue.svg"
import resumes from "../../assets/resumes.svg"
import resumeLightBlueLine from '../../assets/resumeLightBlueLine.svg'
import whiteline from "../../assets/whiteline.svg"
import taya from "../../assets/icons/tayaIcon.svg"
import bluefooter from "../../assets/bluefooter.svg"
import { useTranslation } from "react-i18next";

export default function Resume() {
    const { t, i18n } = useTranslation();

    const resumes = t("resumes", { returnObjects: true }).map((res) => ({
        ...res,
        logo: {
            alrabih,
            alrajihi,
            century21,
            daim,
        }[res.logo],
    }));
  
  return (
    <section id="resume">
      <div className="resume-container">
        <img src={whiteline} className="white-line" />

        <h2>
          <img src={point} className="point" />
          {t("waheedresume.title")}
          <img src={point} className="point" />
        </h2>
        <p className="p-content">{t("waheedresume.experience")}</p>
        <div class="overview">
        <div className="ResumeWahhedFace">
          <img src={logoBack} className="logo-back" />
          {/* <img src={waheedResume} className="waheed-resume" /> */}
          {/* <img src={bluebg} className="bluebg" /> */}
        </div>
        <div className="bluefooterLeft">
          <img src={darkfooter} className="dark" />
        </div>
        <div className="bluefooter">
          <img src={bluefooter} />
          <p>{t("waheedresume.dates")}</p>
        </div>
        {/* <div className='main-resume'> */}
        {/* <img src={resume1} className="resume" /> */}
        <div className="resume-content resume-container-shape">
          <img src={taya} className="tayaIcon" />
          <h2>{t("waheedresume.role")}</h2>
          <p>{t("waheedresume.companyDescription")}</p>

          <br />
          <br />
          <br />
          <p style={{ marginTop: "-30px", color: "#022539" }}>
            {t("waheedresume.company")}
            <br />
            {t("waheedresume.location")}
            <br />
            {t("waheedresume.tayanumber")}
            <br />
            <a style={{ color: "#008B84" }} href="https://taya-re.sa">
              {" "}
              https://taya-re.sa
            </a>
          </p>
        </div>
        {/* </div> */}
        </div>
        <div className="resumes-container">
          <img src={resumeLightBlueLine} className="resumes" />
          <div className="resumes-content">
            {resumes.map((res, index) => (
              <div key={index} className="resume-container-shape resume-shape">
                <img src={res.logo} className="resume-logo" />
                <h2>{res.title}</h2>
                <p>{res.description}</p>
                <div className="tag">
                  <strong>{res.date}</strong>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
